import { createSignal } from '@react-rxjs/utils'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Checkbox } from '../../../form/Checkbox'
import * as Styled from './styled'

const [fulfillTimeAckHighlight$, setFulfillTimeAckHighlight] = createSignal<Record<string, never>>()

export const tickFulfillTimeAckHighlight: () => void = () => setFulfillTimeAckHighlight({})

interface FulfillmentTimeAcknowledgementProps {
  isDisabled: boolean
  defaultChecked: boolean
}

export const FulfillmentTimeAcknowledgement: React.FC<FulfillmentTimeAcknowledgementProps> = ({
  isDisabled,
  defaultChecked,
}) => {
  const [acknowledgementHighlight, setAcknowledgementHighlight] = useState<0 | 1 | null>(null)

  useEffect(() => {
    const subscription = fulfillTimeAckHighlight$.subscribe(() => {
      setAcknowledgementHighlight((prevState) => (prevState ? 0 : 1))
    })
    return () => subscription.unsubscribe()
  }, [])

  const { errors, setValue } = useFormContext()

  useEffect(() => {
    const error = errors['fulfillmentTimeAck']
    if (error) {
      tickFulfillTimeAckHighlight()
    }
  }, [errors])

  useEffect(() => {
    if (defaultChecked) {
      setValue('fulfillmentTimeAck', defaultChecked)
    }
  }, [defaultChecked, setValue])

  return (
    <>
      <Styled.Form $highlight={acknowledgementHighlight}>
        <Checkbox
          disabled={isDisabled}
          label={
            <Styled.Text>
              By checking this box and purchasing this unlabeled product, I acknowledge that the
              order fulfillment time connects with the label creation process. New Labels will take
              approximately 3-5 business days to complete, with additional time if edits are needed.
              Once the label is approved, the order will be processed and will ship within 4-5
              business days.
              <br />
              <br />
              Please note that order lead times are estimates, subject to change by Designs for
              Health, and do not include the time required for product registration or other related
              legal requirements, if applicable.
            </Styled.Text>
          }
          name="fulfillmentTimeAck"
          rules={{ required: true }}
        />
      </Styled.Form>
    </>
  )
}
